import { useState, useCallback } from 'react';
import ChangePasswordModal from '../components/auth/ChangePasswordModal';

/**
 * Keeps change-password modal state on a parent that stays mounted
 * (dropdown menus unmount their children when closed).
 */
export function useChangePasswordModal() {
  const [open, setOpen] = useState(false);

  const openChangePasswordModal = useCallback(() => {
    setOpen(true);
  }, []);

  const changePasswordModal = (
    <ChangePasswordModal open={open} onOpenChange={setOpen} />
  );

  return {
    openChangePasswordModal,
    changePasswordModal,
  };
}

export default useChangePasswordModal;
